import { Either, left, right } from "fp-ts/lib/Either";
import ExceptionEntity from "../../../../../domain/entities/ExceptionEntity";
import UserEntity from "../../../../../domain/entities/UserEntity";
import UserHostDto from "../../../../dto/impl/UserHostDto";
import di from "../../../../../di/DependencyInjection";
import UserHostApi, { UserHostApiName } from "../../../../settings/UserHostApi";

const GetUsersInBucketApiImpl = async (bucketId: number, page: number, perPage: number): Promise<Either<ExceptionEntity, UserEntity[]>> => {
    try {
        // When bucketId is -1, fetch all users (for counting); otherwise pass bucket_id
        const bucketParam = bucketId > 0 ? `bucket_id=${bucketId}&` : '';
        const relativeUrl = `/users?${bucketParam}page=${page}&per_page=${perPage}&keyword=`;
        const response = await di.get<UserHostApi>(UserHostApiName).get(relativeUrl);
        const data = response.data ?? response;
        const users: UserEntity[] = (Array.isArray(data) ? data : []).map((item: any) => UserHostDto.fromJson(item));
        return right(users);
    } catch (error: any) {
        console.error("GetUsersInBucketApiImpl error:", error);
        return left({ message: error?.message ?? "Error fetching users in bucket" });
    }
};

export default GetUsersInBucketApiImpl;
